import { render, staticRenderFns } from "./m-loading.vue?vue&type=template&id=71bf09d8&"
import script from "./m-loading.vue?vue&type=script&lang=js&"
export * from "./m-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports